import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';

interface MarkdownContentProps {
	content: string;
	className?: string;
	inline?: boolean;
}

const MarkdownContent = ({ content, className, inline = false }: MarkdownContentProps) => {
	if (inline) {
		return (
			<span className={className}>
				<ReactMarkdown
					remarkPlugins={[remarkBreaks]}
					components={{
						a: ({ href, children }) => (
							<a href={href} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">
								{children}
							</a>
						),
						strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
						em: ({ children }) => <em className="italic">{children}</em>,
						p: ({ children }) => <span>{children}</span>,
					}}
				>
					{content}
				</ReactMarkdown>
			</span>
		);
	}

	return (
		<div className={className}>
			<ReactMarkdown
				remarkPlugins={[remarkBreaks]}
				components={{
					a: ({ href, children }) => (
						<a href={href} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2">
							{children}
						</a>
					),
				}}
			>
				{content}
			</ReactMarkdown>
		</div>
	);
};

export default MarkdownContent;
